<template>
  <div class="content-wrapper">
    <div class="content animated fadeIn">

      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">

            <div style="margin-bottom:20px;">

              <template v-if="$i18n.locale == 'tr'">
              <!-- <strong>Your Current Credit: {{ $store.state.user.user.availableCredit }}</strong> -->
              Uygulama içerisinde gerçekleştireceğiniz satın alımlar için
              fatura bilgileriniz burada görüntülendiği gibidir. <br />Firma
              bilgilerinde değişiklik yapmak istediğiniz taktirde bizimle
              <a href="mailto:support@holacon.com">support@holacon.com</a>
              adresinden iletişime geçmeniz yeterlidir.
            </template>
            <template v-else>
              <!-- <strong>Your Current Credit: {{ $store.state.user.user.availableCredit }}</strong> -->
              Your billing information for the purchases you make in the
              application is as shown here <br />
              If you want to make changes in company information, please contact us at
              <a href="mailto:support@holacon.com">support@holacon.com</a>
            </template>
            
            </div>

              <form>
                <div class="row">

                  <div class="form-group col-md-8">
                    <label>{{this.$t('enums.inputTypes.company')}}</label>
                    <el-input v-model="form.title" :readonly="true"></el-input>
                  </div>

                  <div class="form-group col-md-4">
                    <label>{{this.$t('firmNo')}}</label>
                    <el-input
                      v-model="form.organizationNO"
                      :readonly="true"
                    ></el-input>
                  </div>

                  <div class="form-group col-md-8">
                    <label>{{this.$t('officialTitle')}}</label>
                    <el-input
                      v-model="form.invoice.titleOrFullName"
                      :readonly="true"
                    ></el-input>
                  </div>
                  
                  <div class="form-group col-md-4">
                    <label>{{this.$t('billType')}}</label>
                    <el-input
                      :value="form.invoice.type == 1 ? $t('legal') : $t('person')"
                      :readonly="true"
                    ></el-input>
                  </div>

                  <div class="form-group col-md-6">
                    <label>{{this.$t('taxAd')}}</label>
                    <el-input
                      v-model="form.invoice.taxOffice"
                      :readonly="true"
                    ></el-input>
                  </div>
                  <div class="form-group col-md-6">
                    <label>{{this.$t('taxTC')}}</label>
                    <el-input
                      v-model="form.invoice.taxNumberOrIdentity"
                      :readonly="true"
                    ></el-input>
                  </div>
                  <div class="form-group col-md-12">
                    <label>{{this.$t('address')}}</label>
                    <el-input
                      type="textarea"
                      v-model="form.invoice.address"
                      :readonly="true"
                    ></el-input>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FirmInfo",
  metaInfo: {
    title: "Company",
  },
  data() {
    return {
      form: JSON.parse(
        JSON.stringify(this.$store.state.user.user.currentOrganization)
      ),
    };
  },
  methods: {},
};
</script>



// WEBPACK FOOTER //
// src/pages/FirmInfo.vue